export default "__VITE_ASSET__BevYkwH7__"